module.exports = __webpack_public_path__ + "static/media/Finnovex-West-Africa-2024.d5e01f62.png";